import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CampaignsPage } from "@/features/campaigns/CampaignsPage";

const search = z.object({
  status: z.enum(["all", "draft", "scheduled", "sending", "sent"]).optional(),
  channel: z.enum(["all", "email", "sms"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/campaigns/")({
  validateSearch: search,
  component: () => <CampaignsPage search={Route.useSearch()} />,
});
